import { useCallback, useEffect, useRef } from "react";

/**
 * Hook to know if something is still mounted before setting state
 * To use parsimonely
 * @returns function returning a boolean
 */
export function useIsMounted() {
    const isMountedRef = useRef(false);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        };
    }, []);

    // Return a function to get the current value, to avoid potential issues
    return useCallback(() => isMountedRef.current, []);
}